import type { ApiResponse } from '@bower/shared';
import type { HttpClient } from './http-client.types';

export interface ProvisionWorkspaceParams {
  recipientEmail?: string;
  name: string;
  slug?: string;
  description?: string;
  institution?: string;
}

export function getUser(http: HttpClient, userId: string) {
  return http.get(`/users/${userId}`);
}

export function getCurrentUser(http: HttpClient) {
  return http.get('/users/me');
}

export function provisionWorkspace(http: HttpClient, params: ProvisionWorkspaceParams) {
  return http.post<{
    workspaceId: string;
    workspaceSlug: string;
    recipientUserId: string;
    organisationId: string;
    callerJoinedAsSupportSeat: boolean;
  }>('/admin/workspaces', params);
}

export function patchUser(http: HttpClient, userId: string, field: string, value: unknown) {
  return http.patch(`/users/${userId}`, { [field]: value });
}

export function verifyOrcid(
  http: HttpClient,
  orcidId: string,
): Promise<ApiResponse<{ orcidId: string; name: string | null }>> {
  return http.get<{ orcidId: string; name: string | null }>(
    `/users/orcid/verify?id=${encodeURIComponent(orcidId)}`,
  );
}

// === Compliance ===

export function exportUserData(http: HttpClient) {
  return http.get('/compliance/data-export');
}

export function deleteAccount(http: HttpClient) {
  return http.delete('/compliance/account', { data: { confirm: 'DELETE' } });
}

export function revokeSessions(http: HttpClient) {
  return http.post('/compliance/revoke-sessions');
}

export function togglePhiMode(http: HttpClient, enabled: boolean) {
  return http.patch('/workspace/settings/phi', { enabled });
}
